export const SURVEY_CONSTANTS = {
  INPUTS_TYPE: {
    INPUT: {
      name: "input",
    },
    BOOLEAN: {
      name: "boolean",
      styles: {
        thumbs: "thumbs",
        default: "default",
        slider: "slider",
      },
    },
    RATING: {
      name: "rating",
      styles: {
        emojis: "emojis",
        starts: "starts",
        stars: "stars",
        slider: "slider",
      },
    },
    GROUP: {
      name: "group",
    },
  },
};
